import React from 'react'
import './Drawer.css'

export const PaymentMethod = ({ onClose }) => {
  return (
    <>
      <div className='display-1'>
        <div className='display-1 cursor' onClick={onClose}>
          <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24.5" cy="24.5" r="24.5" fill="white" fill-opacity="0.2" />
            <path opacity="0.6" d="M32.251 15.2305C32.8244 14.6571 33.7518 14.6571 34.3252 15.2305C34.8988 15.8039 34.8988 16.7313 34.3252 17.3047L26.8516 24.7773L34.3252 32.251C34.8989 32.8244 34.8988 33.7518 34.3252 34.3252C34.0392 34.6112 33.6634 34.7549 33.2881 34.7549C32.9128 34.7548 32.5369 34.6112 32.251 34.3252L24.7773 26.8516L17.3047 34.3252C17.0187 34.6112 16.6428 34.7548 16.2676 34.7549C15.8923 34.7549 15.5163 34.6113 15.2305 34.3252C14.6568 33.7518 14.6568 32.8244 15.2305 32.251L22.7031 24.7773L15.2305 17.3047C14.6568 16.7313 14.6569 15.8039 15.2305 15.2305C15.8039 14.657 16.7311 14.6571 17.3047 15.2305L24.7773 22.7031L32.251 15.2305Z" fill="white" stroke="white" stroke-width="0.4" />
          </svg>
        </div>
        <div className='drawer-title'>

        </div>
      </div>
    </>
  )
}
